import { useEffect, useState } from 'react';

const DATA_URLS = {
  imperial: '/data/so-what-narratives.json',
  metric: '/data/so-what-narratives-metric.json'
};

const cachedDataByUrl = new Map();
const fetchPromiseByUrl = new Map();

export default function useSoWhatNarratives(unitSystem = 'imperial') {
  const url = DATA_URLS[unitSystem] || DATA_URLS.imperial;
  const cachedData = cachedDataByUrl.get(url) || null;

  const [data, setData] = useState(cachedData);
  const [loading, setLoading] = useState(!cachedData);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cached = cachedDataByUrl.get(url) || null;
    setError(null);
    if (cached) {
      setData(cached);
      setLoading(false);
      return;
    }

    setData(null);
    setLoading(true);

    let isMounted = true;

    // Reuse existing fetch promise if one is in progress
    if (!fetchPromiseByUrl.get(url)) {
      const promise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`Failed to load narratives (${res.status})`);
          return res.json();
        })
        .then(json => {
          cachedDataByUrl.set(url, json);
          return json;
        })
        .finally(() => {
          fetchPromiseByUrl.delete(url);
        });
      fetchPromiseByUrl.set(url, promise);
    }

    fetchPromiseByUrl.get(url)
      .then(json => {
        if (!isMounted) return;
        setData(json);
        setLoading(false);
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err);
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [url]);

  const resolvedData = cachedData || data;
  const resolvedLoading = cachedData ? false : loading;
  const resolvedError = cachedData ? null : error;

  return { data: resolvedData, loading: resolvedLoading, error: resolvedError };
}
